"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SalaryRateButtons = exports.SalaryRangeField = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const antd_1 = require("antd");
const elements_1 = require("@src/components/elements");
const useConfig_1 = require("@src/hooks/useConfig");
const react_intl_1 = require("react-intl");
const styled_components_1 = __importDefault(require("styled-components"));
const styled_breakpoints_1 = require("styled-breakpoints");
const FieldsWrapper = styled_components_1.default.div `
	width: fit-content;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	.ant-form-item-has-error button {
		border: 1px solid ${({ theme }) => theme.color.error};
	}
`;
const InputsWrapper = styled_components_1.default.div `
	display: flex;
	justify-content: space-between;
	width: 100%;
`;
const StyledInputNumber = (0, styled_components_1.default)(elements_1.InputNumber) `
	width: 130px;
`;
const InputNumberWrap = styled_components_1.default.div `
	max-width: 130px;
`;
function checkMinMaxCorrectness({ getFieldValue, setFieldsValue }) {
    const min = getFieldValue('salaryMin');
    const max = getFieldValue('salaryMax');
    if (min && max) {
        if (min >= max) {
            setFieldsValue({ salaryMax: min + 1 });
        }
    }
}
const SalaryRangeField = ({ form, maxRules, minRules, rateRules, dependencies }) => {
    const config = (0, useConfig_1.useConfig)();
    const intl = (0, react_intl_1.useIntl)();
    const radioOptions = config.salaryRates.map(rate => ({
        label: intl.formatMessage({ id: `offer.filter.${rate.value}` }),
        value: rate.value,
    }));
    const onSwitchChange = (value) => {
        if (!value) {
            form.setFieldsValue({
                salaryMin: undefined,
                salaryMax: undefined,
            });
        }
    };
    return ((0, jsx_runtime_1.jsxs)(FieldsWrapper, { children: [(0, jsx_runtime_1.jsx)(antd_1.Form.Item, { label: intl.formatMessage({ id: 'offer.filter.how_big_salary' }), name: "salaryRate", valuePropName: "activeButton", rules: rateRules, dependencies: dependencies, children: (0, jsx_runtime_1.jsx)(exports.SalaryRateButtons, { options: radioOptions, size: "middle", 
                    // @ts-ignore
                    onChange: onSwitchChange }) }), (0, jsx_runtime_1.jsx)(InputsWrapper, { children: (0, jsx_runtime_1.jsx)(antd_1.Form.Item, { noStyle: true, shouldUpdate: (prev, curr) => prev.salaryRate !== curr.salaryRate, children: ({ getFieldValue }) => {
                        return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(InputNumberWrap, { children: (0, jsx_runtime_1.jsx)(antd_1.Form.Item, { name: "salaryMin", label: intl.formatMessage({
                                            id: 'offers.offer_notification_subscription_form.minimum',
                                        }), rules: minRules, children: (0, jsx_runtime_1.jsx)(StyledInputNumber, { disabled: Boolean(!getFieldValue('salaryRate')), placeholder: "0", onBlur: () => checkMinMaxCorrectness({
                                                getFieldValue,
                                                setFieldsValue: form.setFieldsValue,
                                            }) }) }) }), (0, jsx_runtime_1.jsx)(InputNumberWrap, { children: (0, jsx_runtime_1.jsx)(antd_1.Form.Item, { name: "salaryMax", label: intl.formatMessage({
                                            id: 'offers.offer_notification_subscription_form.maximum',
                                        }), rules: maxRules, children: (0, jsx_runtime_1.jsx)(StyledInputNumber, { disabled: Boolean(!getFieldValue('salaryRate')), onBlur: () => checkMinMaxCorrectness({
                                                getFieldValue,
                                                setFieldsValue: form.setFieldsValue,
                                            }), placeholder: intl.formatMessage({ id: 'offer.filter.unlimited' }) }) }) })] }));
                    } }) })] }));
};
exports.SalaryRangeField = SalaryRangeField;
exports.SalaryRateButtons = (0, styled_components_1.default)(elements_1.SwitchButtonsGroup) `
	${(0, styled_breakpoints_1.down)('xs')} {
		.ant-btn {
			font-size: 13px;
		}
	}
`;
